/**
 * Engagement Service
 * Calls the REDEX backend to create payment request engagements
 * via the REDEX portal (Honeyshares REDEX tenant).
 */

import api from './api';

export type RequestType = 'setup' | 'monthly' | 'quarterly' | 'custom-monthly';

export interface RetainerCheckoutPayload {
  tierId: string;
  contactName: string;
  contactEmail: string;
  contactCompany?: string;
  requestTypes: RequestType[];
}

export interface CreatedEngagement {
  id: string;
  title: string;
  type: string;
  amount_cents: number;
  payment_url?: string | null;
}

export interface EngagementResult {
  success: boolean;
  message: string;
  engagements?: CreatedEngagement[];
  partialFailure?: string[];
}

export async function createRetainerEngagement(
  payload: RetainerCheckoutPayload,
): Promise<EngagementResult> {
  const { data } = await api.post<EngagementResult>('/engagements/create', payload);
  return data;
}
